<template>
  <div class="bars">
    <div class="bar-container" v-for="(wave, index) in star.waves" :key="index">
      <div class="bar-item">
        <div class="bar" :style="{ width: wave.value !== undefined ? wave.value + 'px' : '0px', 'background-color': wave.color }"></div>
        <span class="bar-text">{{ wave.value !== undefined ? wave.value + '%' : '' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    star: { type: Object, required: true },
  }
};
</script>

<style lang="scss" scoped>
.bars {
  margin: 1px;
}

.bar-container {
  margin-top: 0px;
}

.bar {
  height: 12px;
  background-color: blue;
}

.bar-item{
  display: flex;
  line-height: 1.0;
  font-size: 12px;
}

.bar-text {
  padding-left: 0.25rem;
}
</style>
